import { createSelector } from 'reselect';
import { getLocale } from '@app/redux/clientLocale/selectors';

export const getLocalization = ({ localization = {} }) => localization;

export const getShowLocalizationSettings = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'showLocalizationSettings' does not exist... Remove this comment to see the full error message
  ({ showLocalizationSettings }) => showLocalizationSettings,
);

export const getLanguageCode = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'code' does not exist on type '{}'.
  ({ code }) => code,
);

// @ts-expect-error ts-migrate(2339) FIXME: Property 'url' does not exist on type '{}'.
export const getUrlCode = createSelector(getLocalization, ({ url }) => url);

export const getLanguage = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'language' does not exist on type '{}'.
  ({ language }) => language,
);

export const getIsNotEnglish = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'language' does not exist on type '{}'.
  ({ language }) => language !== 'English',
);

export const getUrlPrefix = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'urlPrefix' does not exist on type '{}'.
  ({ urlPrefix }) => urlPrefix,
);

export const getPreviousUrlCode = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'previousUrl' does not exist on type '{}'... Remove this comment to see the full error message
  ({ previousUrl }) => previousUrl,
);

export const getSavedLanguage = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'savedLanguage' does not exist on type '{... Remove this comment to see the full error message
  ({ savedLanguage }) => savedLanguage,
);

export const getSelectedRegion = createSelector(
  getLocalization,
  getLocale,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedRegion' does not exist on type '... Remove this comment to see the full error message
  ({ selectedRegion }, { countryCode }): string =>
    selectedRegion || countryCode || 'US',
);

export const getSalesforceLanguageCode = createSelector(
  getLanguageCode,
  getSelectedRegion,
  getUrlPrefix,
  (languageCode, selectedRegion, urlPrefix) => {
    // This logic may seem weird, however salesforce requires that we provide either en_US, en_GB or
    // simply the language code
    const languageHashMap: { [urlPrefix: string]: string } = {
      '/zh-cn/': 'zh_CN',
      '/es-es/': 'es',
      '/es-mx/': 'es',
      '/es-us/': 'es',
      '/zh-tw/': 'zh_TW',
      '/ja-jp/': 'ja',
      '/fr-ca/': 'fr_CA',
    };

    if (
      (languageCode === 'en' && selectedRegion === 'GB') ||
      urlPrefix === '/en-gb/'
    ) {
      return 'en_GB';
    }

    if (languageCode === 'en') {
      return 'en_US';
    }

    if (urlPrefix in languageHashMap) {
      return languageHashMap[urlPrefix];
    }

    return languageCode;
  },
);

export const getTheCountries = createSelector(
  getLocalization,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'allCountries' does not exist on type '{}... Remove this comment to see the full error message
  ({ allCountries = [] }) => allCountries,
);

export const getDynamicallySwappedNameFields = createSelector(
  getLanguageCode,
  (languageCode) => {
    if (languageCode === 'ja' || languageCode === 'zh') {
      return true;
    }

    return false;
  },
);
